






import { Component, Vue } from 'vue-property-decorator'
import Layout from '@/layout/index.vue'

@Component({
  name: "APP",
  components: { lay_out: Layout }
})
export default class App extends Vue {
  created() {
    if(this.$route.query.phone) {
      window.localStorage.setItem('phone', this.$route.query.phone as string)
    }
  }
}

